import React, { useRef} from "react";
import ToggleBar from "../../commoncomponents/toggleBar";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);

function RealTimeTemperature(props) {
  console.log("props ....", props.totalGraph);

  let tempBEnabled = props.tempBEnabled;

  console.log("dateee",  props.totalGraph);

  const dictinarySelection = (value) => {
    return props.utcObj[value];
  };

  const options = {
    title: {
      text: "",
    },

    xAxis: {
      type: "datetime",
      tickInterval:   3600 * 1000,
    },

    tooltip: {
      formatter: function () {
        return this.points.reduce(function (s, point) {
          return (
            s +
            "<br/>" +
            point.series.name +
            ": " +
            "<b>" +
            point.y +
            `\xB0C` +
            "</b>"
          );
        }, "<b>" + dictinarySelection(this.x) + "</b>");
      },
      shared: true,
    },
      //legend: {
      //    enabled: tempBEnabled
      //},
    series: [
      {

        type: "line",
        data: props.totalGraph,
        name: "Sensor A",
        pointStart:props.totalGraph.length>0? props.totalGraph[0][0]:"",
      },
      {
        type: "line",
        data: props.totalGraphSecond,
        name: "Sensor B",
        color: "red",
        visible: tempBEnabled,
        showInLegend: tempBEnabled
        },

    ],

    };
    const chart = useRef();
    const data = <HighchartsReact ref={chart} highcharts={Highcharts} options={options} />;

    const handleChartDownLoad = () => {
        if (chart && chart.current && chart.current.chart) {
            chart.current.chart.exportChart();
        }
     };
  return (
    <ToggleBar
      caption="RealTimeTemperature"
      download={handleChartDownLoad}
      icon="fa-building"
      color="#337ab7"
      content={data}
    />
  );
}

export default RealTimeTemperature;
